<div class="container-fluid appointment-page">
  <div class="appointment-shell">
    <p-sidebar [(visible)]="isPatientVisible" position="left" [modal]="true" dismissible="true"
      [style]="{width:'30vw'}">
      <!-- <div class="col-md-2 border-end p-0 d-flex flex-column"> -->
      <!-- <div class="p-2 border-bottom">
        <h6 class="mb-1 fw-bold">Consultation</h6>
      </div> -->

      <!-- Tabs for Queue and Search -->
      <div class="flex-grow-1 overflow-auto p-1 w-100">
        <!-- Commented out tabview wrapper to remove extra tab header space -->
        <!--
        <p-tabView [(activeIndex)]="pationtIndex" [style]="{width: '100% !important'}">
          <p-tabPanel header="Queue">...</p-tabPanel>
          <p-tabPanel header="Completed" *ngIf="completedQueue.length > 0">...</p-tabPanel>
        </p-tabView>
        -->
        <div class="patient-queue-shell">
          <div class="queue-tab-topbar">
            <div class="queue-title-wrap">
              <h6 class="queue-title mb-0">Consultation Queue</h6>
              <small class="queue-subtitle">
                <ng-container *ngIf="consultationQueueSearchTerm.trim(); else consultationQueueDefaultCount">
                  {{ filteredConsultationQueue.length }} match(es)
                </ng-container>
                <ng-template #consultationQueueDefaultCount>
                  {{ filteredConsultationQueue.length }} patient(s) shown
                </ng-template>
              </small>
            </div>
            <span class="queue-auto-pill">
              <i class="pi pi-sync"></i>
              Auto refresh
            </span>
          </div>

          <div class="queue-search-wrap">
            <i class="pi pi-search queue-search-icon" aria-hidden="true"></i>
            <input
              #consultationQueueSearchInput
              type="text"
              class="queue-search-input"
              [(ngModel)]="consultationQueueSearchTerm"
              placeholder="Search name"
              aria-label="Search consultation queue"
            />
            <button
              *ngIf="consultationQueueSearchTerm"
              type="button"
              class="queue-search-clear"
              (click)="clearConsultationQueueSearch()"
              aria-label="Clear consultation queue search"
            >
              <i class="pi pi-times" aria-hidden="true"></i>
            </button>
          </div>

          <div class="queue-flow-filters">
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="consultationFlowFilter === 'all'"
              (click)="consultationFlowFilter = 'all'"
            >
              <span>All</span>
              <span class="queue-filter-count">{{ consultationFlowCounts.all }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="consultationFlowFilter === 'medicine'"
              (click)="consultationFlowFilter = 'medicine'"
            >
              <span>Medicine Collection</span>
              <span class="queue-filter-count">{{ consultationFlowCounts.medicine }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="consultationFlowFilter === 'normal'"
              (click)="consultationFlowFilter = 'normal'"
            >
              <span>Normal</span>
              <span class="queue-filter-count">{{ consultationFlowCounts.normal }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="consultationFlowFilter === 'home_delivery'"
              (click)="consultationFlowFilter = 'home_delivery'"
            >
              <span>Home Delivery</span>
              <span class="queue-filter-count">{{ consultationFlowCounts.home_delivery }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="consultationFlowFilter === 'domestic'"
              (click)="consultationFlowFilter = 'domestic'"
            >
              <span>Domestic</span>
              <span class="queue-filter-count">{{ consultationFlowCounts.domestic }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="consultationFlowFilter === 'international'"
              (click)="consultationFlowFilter = 'international'"
            >
              <span>International</span>
              <span class="queue-filter-count">{{ consultationFlowCounts.international }}</span>
            </button>
          </div>

          <p-scrollPanel [style]="{ width: '100%', height: completedQueue.length > 0 ? '38vh' : '62vh' }">
            <div *ngIf="filteredConsultationQueue.length > 0; else emptyConsultationQueue" class="patient-queue-list">
              <button *ngFor="let item of filteredConsultationQueue" type="button" class="patient-queue-card" [ngClass]="getColorClass(item.status)">
                <span
                  class="queue-intake-note"
                  *ngIf="item.appointment_notes"
                  [title]="getReceptionNoteTooltip(item.appointment_notes, item.medicine_intent)"
                  [attr.aria-label]="'Reception note: ' + getReceptionNoteTooltip(item.appointment_notes, item.medicine_intent)"
                >
                  <span
                    *ngIf="item.medicine_intent"
                    class="medicine-intent-badge"
                    [ngClass]="'medicine-intent-badge--' + item.medicine_intent"
                  >{{ getMedicineIntentShort(item.medicine_intent) }}</span>
                  <i class="pi pi-whatsapp" aria-hidden="true"></i>
                </span>
                <div class="queue-card-top">
                  <span class="queue-patient-name">{{ item.name }}</span>
                  <div class="queue-card-top-badges">
                    <span *ngIf="item.medicine_collection" class="medicine-badge" title="Medicine Collection">
                      <small>MC</small>
                    </span>
                    <span
                      *ngIf="getDeliveryType(item) as deliveryType"
                      class="delivery-badge"
                      [ngClass]="'delivery-badge--' + deliveryType"
                      [title]="getDeliveryBadgeLabel(item)"
                    >
                      <i class="pi" [ngClass]="getDeliveryBadgeIcon(item)" aria-hidden="true"></i>
                      <span class="delivery-badge-text">{{ getDeliveryBadgeShort(item) }}</span>
                    </span>
                    <span
                      *ngIf="hasKeptBalance(item)"
                      class="balance-badge"
                      [title]="'Patient kept balance ₹' + formatRupee(item.personal_dues)"
                    >
                      Bal ₹{{ formatRupee(item.personal_dues) }}
                    </span>
                  </div>
                </div>

                <div class="queue-card-bottom">
                  <span class="queue-status-chip">{{ item.status || 'pending' }}</span>
                  <div class="queue-card-bottom-end">
                    <div class="queue-timing-group">
                      <span class="queue-time-pill">
                        <i class="pi pi-clock"></i>
                        {{ formatTime(item.time) }}
                      </span>
                      <span
                        *ngIf="shouldShowWaitingBadge(item)"
                        class="waiting-time-pill"
                        [class.waiting-time-pill--urgent]="isWaitingUrgent(item)"
                        title="Waiting since check-in"
                      >
                        <span class="waiting-time-pill__label">Waiting time</span>
                        <span class="waiting-time-pill__value">{{ formatWaitingTime(item) }}</span>
                      </span>
                      <button
                        *ngIf="item.status === 'scheduled' && !item._checkInPending"
                        type="button"
                        class="queue-action-btn"
                        (click)="requestCheckIn(item, $event)">
                        Check In
                      </button>
                      <button
                        *ngIf="item._checkInPending"
                        type="button"
                        class="queue-action-btn queue-action-btn-undo"
                        (click)="undoCheckIn(item, $event)">
                        Undo
                      </button>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </p-scrollPanel>

          <ng-template #emptyConsultationQueue>
            <div class="queue-empty-state">
              <i class="pi" [ngClass]="consultationQueueSearchTerm.trim() ? 'pi-search' : 'pi-inbox'"></i>
              <p class="mb-0" *ngIf="consultationQueueSearchTerm.trim(); else noConsultationQueueEntries">
                No matches for "{{ consultationQueueSearchTerm.trim() }}".
              </p>
              <ng-template #noConsultationQueueEntries>
                <p class="mb-0">No patients in queue right now.</p>
              </ng-template>
            </div>
          </ng-template>
        </div>

        <div *ngIf="completedQueue.length > 0" class="patient-queue-shell">
          <div class="queue-tab-topbar">
            <div class="queue-title-wrap">
              <h6 class="queue-title mb-0">Completed Queue</h6>
              <small class="queue-subtitle">{{ completedQueue.length }} patient(s)</small>
            </div>
            <span class="queue-auto-pill queue-auto-pill-completed">
              <i class="pi pi-check-circle"></i>
              Completed
            </span>
          </div>

          <p-scrollPanel [style]="{ width: '100%', height: '24vh' }">
            <div class="patient-queue-list">
              <button *ngFor="let item of completedQueue" type="button" class="patient-queue-card" [ngClass]="getColorClass(item.status)">
                <span
                  class="queue-intake-note"
                  *ngIf="item.appointment_notes"
                  [title]="getReceptionNoteTooltip(item.appointment_notes, item.medicine_intent)"
                  [attr.aria-label]="'Reception note: ' + getReceptionNoteTooltip(item.appointment_notes, item.medicine_intent)"
                >
                  <span
                    *ngIf="item.medicine_intent"
                    class="medicine-intent-badge"
                    [ngClass]="'medicine-intent-badge--' + item.medicine_intent"
                  >{{ getMedicineIntentShort(item.medicine_intent) }}</span>
                  <i class="pi pi-whatsapp" aria-hidden="true"></i>
                </span>
                <div class="queue-card-top">
                  <span class="queue-patient-name">{{ item.name }}</span>
                  <div class="queue-card-top-badges">
                    <span *ngIf="item.medicine_collection" class="medicine-badge" title="Medicine Collection">
                      <small>MC</small>
                    </span>
                    <span
                      *ngIf="getDeliveryType(item) as deliveryType"
                      class="delivery-badge"
                      [ngClass]="'delivery-badge--' + deliveryType"
                      [title]="getDeliveryBadgeLabel(item)"
                    >
                      <i class="pi" [ngClass]="getDeliveryBadgeIcon(item)" aria-hidden="true"></i>
                      <span class="delivery-badge-text">{{ getDeliveryBadgeShort(item) }}</span>
                    </span>
                    <span
                      *ngIf="hasKeptBalance(item)"
                      class="balance-badge"
                      [title]="'Patient kept balance ₹' + formatRupee(item.personal_dues)"
                    >
                      Bal ₹{{ formatRupee(item.personal_dues) }}
                    </span>
                  </div>
                </div>

                <div class="queue-card-bottom">
                  <span class="queue-status-chip">{{ item.status || 'completed' }}</span>
                  <div class="queue-card-bottom-end">
                    <div class="queue-timing-group">
                      <span class="queue-time-pill">
                        <i class="pi pi-clock"></i>
                        {{ formatTime(item.time) }}
                      </span>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </p-scrollPanel>
        </div>
      </div>
    <!-- </div> -->
    </p-sidebar>

    <button class="sidebar-toggle-btn sidebar-toggle-btn-left sidebar-toggle-btn-patient" *ngIf="!isPatientVisible"
      (click)="openQueueSidebar()" type="button" aria-label="Open consultation queue">
      <i class="pi pi-users sidebar-toggle-icon" aria-hidden="true"></i>
    </button>
    

    <div class="appointment-calendar-wrap">
      <app-calendar></app-calendar>
    </div>

      <p-sidebar [(visible)]="isMedicineVisible" position="right" [modal]="true" dismissible="true"
      [style]="{width:'30vw'}" styleClass="medicine-queue-sidebar">
      <!-- <div class="p-2 border-bottom">
        <h6 class="mb-1 fw-bold">Medicine Collection</h6>
      </div> -->

      <!-- Tabs for Queue and Search -->
      <div class="flex-grow-1 p-1 w-100 medicine-queue-wrapper">
        <!-- Commented out tabview wrapper to remove extra tab header space -->
        <!--
        <p-tabView>
          <p-tabPanel header="Queue">...</p-tabPanel>
        </p-tabView>
        -->
        <div class="patient-queue-shell medicine-queue-shell">
          <div class="queue-tab-topbar">
            <div class="queue-title-wrap">
              <h6 class="queue-title mb-0">Medicine Collection Queue</h6>
              <small class="queue-subtitle">
                <ng-container *ngIf="medicineQueueSearchTerm.trim(); else mcQueueDefaultCount">
                  {{ filteredMedicineCollectionQueue.length }} match(es)
                </ng-container>
                <ng-template #mcQueueDefaultCount>
                  {{ filteredMedicineCollectionQueue.length }} patient(s) shown
                </ng-template>
              </small>
            </div>
            <span class="queue-auto-pill">
              <i class="pi pi-sync"></i>
              Auto refresh
            </span>
          </div>

          <div class="queue-search-wrap">
            <i class="pi pi-search queue-search-icon" aria-hidden="true"></i>
            <input
              type="text"
              class="queue-search-input"
              [(ngModel)]="medicineQueueSearchTerm"
              placeholder="Search name"
              aria-label="Search medicine collection queue"
            />
            <button
              *ngIf="medicineQueueSearchTerm"
              type="button"
              class="queue-search-clear"
              (click)="clearMedicineQueueSearch()"
              aria-label="Clear medicine queue search"
            >
              <i class="pi pi-times" aria-hidden="true"></i>
            </button>
          </div>

          <div class="queue-flow-filters">
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="medicineQueueFlowFilter === 'all'"
              (click)="medicineQueueFlowFilter = 'all'"
            >
              <span>All</span>
              <span class="queue-filter-count">{{ medicineQueueFlowCounts.all }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="medicineQueueFlowFilter === 'medicine'"
              (click)="medicineQueueFlowFilter = 'medicine'"
            >
              <span>Medicine Collection</span>
              <span class="queue-filter-count">{{ medicineQueueFlowCounts.medicine }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="medicineQueueFlowFilter === 'normal'"
              (click)="medicineQueueFlowFilter = 'normal'"
            >
              <span>Normal</span>
              <span class="queue-filter-count">{{ medicineQueueFlowCounts.normal }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="medicineQueueFlowFilter === 'home_delivery'"
              (click)="medicineQueueFlowFilter = 'home_delivery'"
            >
              <span>Home Delivery</span>
              <span class="queue-filter-count">{{ medicineQueueFlowCounts.home_delivery }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="medicineQueueFlowFilter === 'domestic'"
              (click)="medicineQueueFlowFilter = 'domestic'"
            >
              <span>Domestic</span>
              <span class="queue-filter-count">{{ medicineQueueFlowCounts.domestic }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="medicineQueueFlowFilter === 'international'"
              (click)="medicineQueueFlowFilter = 'international'"
            >
              <span>International</span>
              <span class="queue-filter-count">{{ medicineQueueFlowCounts.international }}</span>
            </button>
          </div>

          <!-- <p-scrollPanel [style]="{ width: '100%', height: '100vh' }"> -->
            <div *ngIf="filteredMedicineCollectionQueue.length > 0; else emptyMedicineQueue" class="patient-queue-list">
              <button *ngFor="let item of filteredMedicineCollectionQueue" type="button" class="patient-queue-card" [ngClass]="getColorClass(item.status)"
                [class.is-locked]="isQueuePatientLocked(item)"
                (click)="showMedicineDialog(item)">
                <div class="queue-card-top">
                  <span class="queue-patient-name">{{ item.name }}</span>
                  <div class="queue-card-top-badges">
                    <span *ngIf="item.medicine_collection" class="medicine-badge" title="Medicine Collection">
                      <small>MC</small>
                    </span>
                    <span
                      *ngIf="getDeliveryType(item) as deliveryType"
                      class="delivery-badge"
                      [ngClass]="'delivery-badge--' + deliveryType"
                      [title]="getDeliveryBadgeLabel(item)"
                    >
                      <i class="pi" [ngClass]="getDeliveryBadgeIcon(item)" aria-hidden="true"></i>
                      <span class="delivery-badge-text">{{ getDeliveryBadgeShort(item) }}</span>
                    </span>
                    <span
                      *ngIf="hasKeptBalance(item)"
                      class="balance-badge"
                      [title]="'Patient kept balance ₹' + formatRupee(item.personal_dues)"
                    >
                      Bal ₹{{ formatRupee(item.personal_dues) }}
                    </span>
                  </div>
                </div>

                <div class="queue-card-bottom">
                  <span class="queue-status-chip">{{ item.status || 'pending' }}</span>
                  <span class="queue-lock" *ngIf="isQueuePatientLocked(item)">
                    <i class="pi pi-lock" aria-hidden="true"></i>
                    Locked
                  </span>
                  <div class="queue-card-bottom-end">
                    <div class="queue-timing-group">
                      <span class="queue-time-pill">
                        <i class="pi pi-clock"></i>
                        {{ formatTime(item.time) }}
                        <span *ngIf="item.formatdate" class="queue-date-inline">
                          <i class="pi pi-calendar"></i>
                          {{ item.formatdate }}
                        </span>
                      </span>
                      <span
                        *ngIf="shouldShowWaitingBadge(item)"
                        class="waiting-time-pill"
                        [class.waiting-time-pill--urgent]="isWaitingUrgent(item)"
                        title="Waiting since check-in"
                      >
                        <span class="waiting-time-pill__label">Waiting time</span>
                        <span class="waiting-time-pill__value">{{ formatWaitingTime(item) }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          <!-- </p-scrollPanel> -->

          <ng-template #emptyMedicineQueue>
            <div class="queue-empty-state">
              <i class="pi" [ngClass]="medicineQueueSearchTerm.trim() ? 'pi-search' : 'pi-check-circle'"></i>
              <p class="mb-0" *ngIf="medicineQueueSearchTerm.trim(); else noMcEntries">
                No matches for "{{ medicineQueueSearchTerm.trim() }}".
              </p>
              <ng-template #noMcEntries>
                <p class="mb-0">No medicine queue entries right now.</p>
              </ng-template>
            </div>
          </ng-template>
        </div>
      </div>
      </p-sidebar>

    <button class="sidebar-toggle-btn sidebar-toggle-btn-right sidebar-toggle-btn-medicine" *ngIf="!isMedicineVisible"
      (click)="openMedicineQueueSidebar()" type="button" aria-label="Open medicine queue">
      <i class="pi pi-envelope sidebar-toggle-icon" aria-hidden="true"></i>
    </button>
  </div>
</div>

<p-dialog
  [draggable]="false"
  [modal]="true"
  [(visible)]="visible"
  (onHide)="clearDeskChatPatient()"
  [showHeader]="false"
  [dismissableMask]="true"
  appendTo="body"
  [baseZIndex]="12000"
  [autoZIndex]="true"
  [style]="{ width: 'min(96vw, 50rem)' }"
  [contentStyle]="{ padding: '0', overflow: 'hidden' }"
  [maskStyleClass]="'dispense-dialog-mask'"
  styleClass="dispense-dialog"
  *ngIf="selectedPatient"
>
  <div class="dispense-shell">
    <header class="dispense-header">
      <h2 class="dispense-header-title">Dispense Medicines</h2>
      <button type="button" class="dispense-header-close" (click)="visible = false" aria-label="Close">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </header>

    <div class="dispense-content">
      <section class="dispense-patient-card" aria-label="Patient and prescription">
        <div class="dispense-patient-header">
          <span class="dispense-patient-avatar" aria-hidden="true">
            <i class="pi pi-user"></i>
          </span>
          <div class="dispense-patient-meta">
            <h3 class="dispense-patient-name">{{ selectedPatient.name || '—' }}</h3>
            <div class="dispense-patient-schedule">
              <span class="dispense-schedule-chip">
                <i class="pi pi-calendar" aria-hidden="true"></i>
                {{ getDispensePickupDate(selectedPatient) }}
              </span>
              <span class="dispense-schedule-chip" *ngIf="selectedPatient.time">
                <i class="pi pi-clock" aria-hidden="true"></i>
                {{ formatTime(selectedPatient.time) }}
              </span>
            </div>
          </div>
        </div>

        <div
          class="dispense-prescription-grid"
          [class.dispense-prescription-grid--single]="!selectedPatient.notes"
        >
          <div class="dispense-prescription-block dispense-prescription-block--medicines">
            <span class="dispense-prescription-label">
              <i class="pi pi-box" aria-hidden="true"></i>
              Medicines
            </span>
            <div class="dispense-prescription-content dispense-prescription-content--medicines">
              {{ selectedPatient.medicines?.trim() || 'No medicines listed.' }}
            </div>
          </div>

          <div class="dispense-prescription-block" *ngIf="selectedPatient.notes">
            <span class="dispense-prescription-label">
              <i class="pi pi-file-edit" aria-hidden="true"></i>
              Notes
            </span>
            <div class="dispense-prescription-content">
              {{ selectedPatient.notes }}
            </div>
          </div>
        </div>
      </section>

      <section class="dispense-billing" aria-label="Payment and delivery">
        <div class="dispense-billing-header">
          <div class="dispense-billing-heading">
            <h4 class="dispense-billing-title">Payment &amp; Delivery</h4>
            <p class="dispense-billing-subtitle">Collect fees and confirm delivery type</p>
          </div>
          <div class="dispense-flow-row">
            <button
              type="button"
              class="dispense-flow-badge dispense-flow-badge--medicine"
              [class.is-active]="selectedPatient.medicine_collection"
              (click)="setDialogMedicineCollection(!selectedPatient.medicine_collection)"
              pTooltip="Medicine"
              tooltipPosition="bottom"
              tooltipStyleClass="dispense-flow-tooltip"
              aria-label="Medicine"
            >
              <i class="pi pi-box" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              class="dispense-flow-badge"
              *ngFor="let option of deliveryTypeOptions"
              [ngClass]="'dispense-flow-badge--' + option.value"
              [class.is-active]="isDialogDeliveryTypeActive(option.value)"
              (click)="setDialogDeliveryType(option.value)"
              [pTooltip]="option.label"
              tooltipPosition="bottom"
              tooltipStyleClass="dispense-flow-tooltip"
              [attr.aria-label]="option.label"
            >
              <i class="pi" [ngClass]="option.icon" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div class="dispense-billing-body">
          <div class="dispense-billing-free" *ngIf="selectedPatient.is_free">
            <i class="pi pi-check-circle" aria-hidden="true"></i>
            No payment required for this free visit.
          </div>

          <ng-container *ngIf="!selectedPatient.is_free">
            <div class="billing-overview">
              <div class="billing-overview-card billing-overview-card--readonly">
                <span class="billing-overview-label">Card dues</span>
                <span class="billing-overview-value">₹ {{ formatRupee(selectedPatient.card_dues) }}</span>
                <span class="billing-overview-hint">Outstanding on card</span>
              </div>
              <div class="billing-overview-card billing-overview-card--fees">
                <span class="billing-overview-label">Visit fees</span>
                <span class="billing-overview-value">₹ {{ formatRupee(selectedPatient.visit_fees) }}</span>
                <span class="billing-overview-hint">Fee for this visit</span>
              </div>
              <div
                class="billing-overview-card billing-overview-card--dues billing-overview-card--editable"
                [class.has-dues]="hasKeptBalance(selectedPatient)"
              >
                <label class="billing-overview-label" for="dispense_personal_dues">Balance</label>
                <div class="billing-amount-input billing-amount-input--overview">
                  <span class="billing-amount-prefix">₹</span>
                  <input
                    id="dispense_personal_dues"
                    type="number"
                    min="0"
                    class="billing-amount-field billing-amount-field--overview"
                    [(ngModel)]="selectedPatient.personal_dues"
                    (input)="onBalanceChange()"
                  />
                </div>
                <span class="billing-overview-hint">Amount the patient still owes</span>
              </div>
            </div>

            <div>
              <span class="billing-section-label">Collection</span>
              <div class="billing-collection-grid">
                <div class="billing-collection-item">
                  <label class="billing-collection-label" for="dispense_received_cash">
                    <i class="pi pi-wallet" aria-hidden="true"></i>
                    Cash
                  </label>
                  <div class="billing-amount-input">
                    <span class="billing-amount-prefix">₹</span>
                    <input
                      id="dispense_received_cash"
                      type="number"
                      min="0"
                      class="billing-amount-field"
                      [(ngModel)]="selectedPatient.received_cash"
                      (input)="onCollectionAmountChange('received_cash')"
                    />
                  </div>
                </div>
                <div class="billing-collection-item">
                  <label class="billing-collection-label" for="dispense_received_online">
                    <i class="pi pi-credit-card" aria-hidden="true"></i>
                    Online / UPI
                  </label>
                  <div class="billing-amount-input">
                    <span class="billing-amount-prefix">₹</span>
                    <input
                      id="dispense_received_online"
                      type="number"
                      min="0"
                      class="billing-amount-field"
                      [(ngModel)]="selectedPatient.received_online"
                      (input)="onCollectionAmountChange('received_online')"
                    />
                  </div>
                </div>
                <div class="billing-total-row">
                  <span class="billing-total-label">Total received</span>
                  <span class="billing-total-value">₹ {{ formatRupee(getTotalReceived(selectedPatient)) }}</span>
                </div>
              </div>
            </div>

            <div class="dispense-billing-free" *ngIf="isPaymentSettled(selectedPatient) && !hasKeptBalance(selectedPatient)">
              <i class="pi pi-check-circle" aria-hidden="true"></i>
              Visit fees collected. You can complete the appointment.
            </div>
          </ng-container>
        </div>
      </section>
    </div>

    <footer class="dispense-footer">
      <button type="button" class="dispense-footer-btn dispense-footer-btn--cancel" (click)="visible = false">
        Cancel
      </button>
      <button
        type="button"
        class="dispense-footer-btn dispense-footer-btn--cash"
        *ngIf="!selectedPatient.is_free"
        [disabled]="!canCollectCashPayment(selectedPatient)"
        [title]="canCollectCashPayment(selectedPatient) ? 'Save collection and balance' : 'Enter cash or a kept balance to save without completing'"
        (click)="collectPaymentOnly(selectedPatient)"
      >
        Cash Payment
      </button>
      <button
        type="button"
        class="dispense-footer-btn dispense-footer-btn--online"
        *ngIf="!selectedPatient.is_free"
        [disabled]="!canInitiateOnlinePayment(selectedPatient)"
        (click)="initiatePayment(selectedPatient)"
      >
        Online Payment
      </button>
      <button
        type="button"
        class="dispense-footer-btn dispense-footer-btn--complete"
        (click)="confirmCompleteAppointment(selectedPatient)"
      >
        Complete Appointment
      </button>
    </footer>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="completeConfirmVisible"
  [modal]="true"
  [draggable]="false"
  [closable]="false"
  [showHeader]="false"
  [dismissableMask]="true"
  appendTo="body"
  [baseZIndex]="12000"
  [autoZIndex]="true"
  maskStyleClass="complete-appt-dialog-mask"
  styleClass="complete-appt-dialog"
  [style]="{ width: 'min(92vw, 26rem)' }"
  (onHide)="cancelCompleteAppointment()"
>
  <div class="complete-appt-shell">
    <header class="complete-appt-header">
      <div class="complete-appt-header-copy">
        <span class="complete-appt-kicker">Medicine queue</span>
        <h2 class="complete-appt-title">Complete appointment?</h2>
      </div>
      <button
        type="button"
        class="complete-appt-close"
        (click)="cancelCompleteAppointment()"
        aria-label="Close"
      >
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </header>

    <div class="complete-appt-body">
      <div class="complete-appt-patient">
        <span class="complete-appt-avatar" aria-hidden="true">
          {{ completeConfirmPatientInitials }}
        </span>
        <div class="complete-appt-patient-meta">
          <span class="complete-appt-patient-name">{{ completeConfirmPatientName }}</span>
          <span class="complete-appt-patient-hint">Ready to leave the medicine queue</span>
        </div>
      </div>

      <ul class="complete-appt-points">
        <li>
          <i class="pi pi-wallet" aria-hidden="true"></i>
          <span>Payment details for this visit will be saved</span>
        </li>
        <li>
          <i class="pi pi-check-circle" aria-hidden="true"></i>
          <span>Appointment status will change to completed</span>
        </li>
        <li>
          <i class="pi pi-inbox" aria-hidden="true"></i>
          <span>Patient will be removed from the medicine queue</span>
        </li>
      </ul>
    </div>

    <footer class="complete-appt-footer">
      <button
        type="button"
        class="complete-appt-btn complete-appt-btn--stay"
        (click)="cancelCompleteAppointment()"
      >
        Stay
      </button>
      <button
        type="button"
        class="complete-appt-btn complete-appt-btn--confirm"
        (click)="acceptCompleteAppointment()"
      >
        <i class="pi pi-check" aria-hidden="true"></i>
        Yes, complete
      </button>
    </footer>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="switchPatientConfirmVisible"
  [modal]="true"
  [draggable]="false"
  [closable]="false"
  [showHeader]="false"
  [dismissableMask]="true"
  appendTo="body"
  [baseZIndex]="13000"
  [autoZIndex]="true"
  maskStyleClass="switch-patient-dialog-mask"
  styleClass="switch-patient-dialog"
  [style]="{ width: 'min(92vw, 28rem)' }"
  (onHide)="cancelSwitchPatient()"
>
  <div class="switch-patient-shell">
    <header class="switch-patient-header">
      <div class="switch-patient-header-copy">
        <span class="switch-patient-kicker">Medicine queue</span>
        <h2 class="switch-patient-title">Finish the previous patient first</h2>
      </div>
      <button
        type="button"
        class="switch-patient-close"
        (click)="cancelSwitchPatient()"
        aria-label="Close"
      >
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </header>

    <div class="switch-patient-body">
      <p class="switch-patient-message">
        <strong>{{ switchConfirmPreviousName }}</strong>
        is still open.
        <strong>{{ switchConfirmCurrentName }}</strong>
        stays locked until that visit is completed.
      </p>

      <div class="switch-patient-current">
        <span class="switch-patient-avatar" aria-hidden="true">
          {{ switchConfirmCurrentInitials }}
        </span>
        <div class="switch-patient-meta">
          <span class="switch-patient-name">{{ switchConfirmCurrentName }}</span>
          <span class="switch-patient-hint">Dispense medicines stays closed</span>
        </div>
      </div>
    </div>

    <footer class="switch-patient-footer">
      <button
        type="button"
        class="switch-patient-btn switch-patient-btn--stay"
        (click)="cancelSwitchPatient()"
      >
        OK
      </button>
    </footer>
  </div>
</p-dialog>
